import { Button } from "antd";
import AvatarPlaceholder from "../../../assets/web/images/avatar-placeholder.png";
import StoryBanner from "../../../assets/web/images/story-banner.png";

export default function StoryCard() {
  return (
    <div className="border border-slate-100 rounded-md">
      <img src={StoryBanner} className="w-full" alt="Story Banner" />
      <div className="p-4">
        <div className="flex justify-between">
          <div className="flex gap-2">
            <img src={AvatarPlaceholder} alt="Avatar Placeholder" />
            <div className="text-sm">
              <div className="font-semibold">Sheba Business</div>
              <div>Sen 22, 2020</div>
            </div>
          </div>
          <div>2 Min read</div>
        </div>
        <div className="font-bold text-2xl mt-3 mb-2">
          5 Best HR Software in Bangladesh in 2022
        </div>
        <div>
          Bangladesh is constantly moving forward to digitalization. This era of
          digitalization is being mostly fueled by the....
        </div>
        <Button
          type="default"
          className="mt-4 border-webPrimary text-webPrimary"
        >
          Read more
        </Button>
      </div>
    </div>
  );
}
